function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 0A11.95 11.95 0 00.847 7.553h22.306A11.95 11.95 0 0012 0zM12 24c5.294 0 9.741-3.459 11.365-8.188H.635C2.26 20.542 6.705 24 12 24z",
  fill: "#82AFFF"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 12c0 1.341.212 2.612.635 3.812h22.73c.423-1.2.635-2.47.635-3.812 0-1.553-.282-3.035-.847-4.447H.847A11.863 11.863 0 000 12z",
  fill: "#F5F5F5"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.353,
  cy: 11.647,
  r: 2.471,
  fill: "#FFE15A"
});
function SvgFlagAr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}
export default __webpack_public_path__ + "/img/flag_ar.svg";
export { SvgFlagAr as ReactComponent };